import { awaitTimer } from "../experience/utils";
const splash = <HTMLElement>document.querySelector('.splash');
const permissions = <HTMLElement>document.querySelector('.permissions');
const permissions_loader = <HTMLElement>document.querySelector('.permissions_loader');
const permissions_loaderIcon = <HTMLElement>document.querySelector('.permissions_loaderIcon');
const permissions_main = <HTMLElement>document.querySelector('.permissions main');
const draw = <HTMLElement>document.querySelector('.draw');
const prompt = <HTMLElement>document.querySelector('.prompt');
const prompt_heading = <HTMLElement>document.querySelector('.prompt_heading');
const prompt_subheading = <HTMLElement>document.querySelector('.prompt_subheading');
const prompt_footer = <HTMLElement>document.querySelector('.prompt footer');
const prompt_button = <HTMLElement>document.querySelector('.prompt_button');
const intro = <HTMLElement>document.querySelector('.intro');
const gyroPrompt = <HTMLElement>document.querySelector('.gyroPrompt');
const gyroPrompt_star1 = <HTMLElement>document.querySelector('.gyroPrompt_star1');
const gyroPrompt_star2 = <HTMLElement>document.querySelector('.gyroPrompt_star2');
const gyroPrompt_greenCircle = <HTMLElement>document.querySelector('.gyroPrompt_greenCircle');
const gyroPrompt_redCircle = <HTMLElement>document.querySelector('.gyroPrompt_redCircle');
const intro_1 = <HTMLElement>document.querySelector('.intro_1');
const intro_2 = <HTMLElement>document.querySelector('.intro_2');
const intro_footer = <HTMLElement>document.querySelector('.intro footer');
const lookAround_prompt = <HTMLElement>document.querySelector('.lookAround_prompt');
const lookAround_prompt_header = <HTMLElement>document.querySelector('.lookAround_prompt header');
const penSelection = <HTMLElement>document.querySelector('.penSelection');
const penSelection_colors = <HTMLElement>document.querySelector('.penSelection_colors');
const penSelection_hand = <HTMLElement>document.querySelector('.penSelection_hand img');
const tutorial = <HTMLImageElement>document.querySelector('.tutorial');
const draw_pen = <HTMLImageElement>document.querySelector('.draw_penButton img');
const draw_infoButton = <HTMLImageElement>document.querySelector('.draw_infoButton');
const draw_colour = <HTMLDivElement>document.querySelector('.draw_colourButton div');
const draw_buttonContainer = <HTMLDivElement>document.querySelector('.draw_buttonContainer');
const draw_cameraButton = <HTMLButtonElement>document.querySelector('.draw_cameraButton');
// const draw_intro = <HTMLDivElement>document.querySelector('.draw_intro')
// const draw_tutorialText = <HTMLDivElement>document.querySelector('.draw_tutorialText')
const draw_hand = <HTMLDivElement>document.querySelector('.draw_hand')
const draw_hand_img = <HTMLDivElement>document.querySelector('.draw_hand img')
const draw_deleteMenu = <HTMLDivElement>document.querySelector('.draw_deleteMenu');

let draw_deleteButton = <HTMLButtonElement>document.querySelector('.draw_deleteButton');
let draw_eraserButton = <HTMLButtonElement>document.querySelector('.draw_eraserButton');
let draw_penButton = <HTMLButtonElement>document.querySelector('.draw_penButton');
let draw_colourButton = <HTMLButtonElement>document.querySelector('.draw_colourButton');
let draw_undoButton = <HTMLButtonElement>document.querySelector('.draw_undoButton');

let download = <HTMLElement>document.querySelector('.download');
let download_video = <HTMLVideoElement>document.querySelector('.download_video');
let download_image = <HTMLImageElement>document.querySelector('.download_image');
let download_saveButton = <HTMLButtonElement>document.querySelector('.download_saveButton');
let download_shareButton = <HTMLButtonElement>document.querySelector('.download_shareButton');
let download_saveShareButton = <HTMLButtonElement>document.querySelector('.download_saveShareButton');
let draw_cameraLoader = <HTMLDivElement>document.querySelector('.draw_cameraLoader');

const draw_buttons = [draw_deleteButton, draw_eraserButton, draw_penButton, draw_colourButton, draw_undoButton];

export function hideSplash() {
    splash.style.display = 'none';
}

export function revealPermissions() {
    permissions.style.display = 'flex';
}

export function revealPermissionsLoader() {
    permissions_main.classList.add('fadeOut');
    awaitTimer(500).then(() => {
        permissions_main.style.display = 'none';
        permissions_loader.classList.add('fadeIn');
    });
}

export function hidePermissions() {
    permissions.classList.add('fadeOut');
    awaitTimer(500).then(() => {
        permissions.style.display = 'none';
        permissions_loaderIcon.classList.remove('rotate');
    })
}

export function revealPrompt() {
    prompt.style.display = 'flex';
    prompt.classList.add('fadeIn');
}

export function hidePrompt() {
    prompt.style.display = 'none';
}

export function revealLookAroundPrompt() {
    lookAround_prompt.style.display = 'flex';
    lookAround_prompt.style.opacity = '0'
    lookAround_prompt.classList.add('fadeIn')
    lookAround_prompt_header.style.display = 'flex'
    lookAround_prompt_header.classList.add('moveDownwards')
}

export function hideLookAroundPrompt() {
    return new Promise<void>((resolve, reject) => {
        console.log('fade out hide look around prompt')
        lookAround_prompt.classList.remove('fadeIn')
        lookAround_prompt.classList.add('fadeOut')
        lookAround_prompt_header.classList.add('moveUpwards')
        awaitTimer(500).then(() => {
            lookAround_prompt.style.display = 'none';
            resolve();
        })
    })
}

export function hideIntro() {
    intro.style.display = 'none';
}

export function revealIntro1() {
    intro_1.style.display = 'flex';
    intro_1.classList.add("fadeInAndOut");
}

export function revealIntro2() {
    intro_1.style.display = 'none';
    intro_2.style.display = 'flex';
    intro_2.classList.add("fadeInAndOut")
}

export function revealIntro() {
    intro.style.display = 'flex';
}

export function revealGyroPrompt() {
    gyroPrompt.style.display = 'flex';
    gyroPrompt_redCircle.classList.add('float');
    setTimeout(() => {
        gyroPrompt_greenCircle.classList.add('float');
        setTimeout(() => {
            gyroPrompt_star1.classList.add('float');
            setTimeout(() => {
                gyroPrompt_star2.classList.add('float');
            }, 10);
        }, 10);
    }, 10);
}

export function hideGyroPrompt() {
    gyroPrompt.style.display = 'none';
    gyroPrompt_redCircle.classList.remove('float');
    gyroPrompt_greenCircle.classList.remove('float');
    gyroPrompt_star1.classList.remove('float');
    gyroPrompt_star2.classList.remove('float');
}

export function hideIntroFooter() {
    intro_footer.style.opacity = '0';
}

export function hidePenSelection() {
    penSelection.classList.remove('fadeIn')
    penSelection.classList.add('fadeOut')
    awaitTimer(500).then(() => {
        penSelection.style.display = 'none'
    })
}

export function revealPenSelection() {
    penSelection.style.display = 'flex';
    penSelection.style.opacity = '0'
    penSelection.classList.remove('fadeOut')
    penSelection.classList.add('fadeIn')
}


// export function revealDrawIntro() {
//     return new Promise<void>((resolve, reject) => {
//         console.log('reveal Draw intro')
//         draw.style.display = 'flex';
//         draw_buttonContainer.style.display = 'none';
//         draw_cameraButton.style.display = 'none';
//         draw_intro.style.display = 'flex';
//         draw_intro.classList.add('moveDownwards');
//         awaitTimer(5000).then(() => {
//             hideDrawIntro().then(resolve)
//         })
//     })
// }

// export function hideDrawIntro() {
//     return new Promise<void>((resolve, reject) => {
//         console.log('hide Draw intro')
//         draw_intro.classList.add('moveUpwards')
//         awaitTimer(500).then(() => {
//             draw_intro.style.display = 'none'
//             resolve();
//         })
//     })
// }

// export function revealDrawTutorial() {
//     console.log('reveal draw tutorial')
//     //draw_tutorialText.style.display = 'flex'
//     //draw_tutorialText.classList.add('moveDownwards')
//     //awaitTimer(500).then(() => {
//     revealDrawTutorialHand();
//     //})
// }

// export function hideDrawTutorial() {
//     return new Promise<void>((resolve, reject) => {
//         console.log('hide draw tutorial')
//         //draw_tutorialText.classList.add('moveUpwards')
//         awaitTimer(500).then(() => {
//             //draw_tutorialText.style.display = 'none';
//             draw_hand_img.classList.remove('fadeIn');
//             draw_hand_img.classList.add('fadeOut');
//             awaitTimer(500).then(() => {
//                 draw_hand.classList.remove('handSwipe');
//                 resolve();
//             })

//         })
//     });
// }

export function revealDrawTutorialHand() {
    awaitTimer(500).then(() => {
        console.log('reveal draw tutorial hand');
        draw_hand_img.classList.remove('fadeOut');
        draw_hand_img.classList.add('fadeIn');
        draw_hand.classList.add('handSwipe');
    })
}

export function hideDrawTutorialHand() {
    console.log('hide draw tutorial hand');
    draw_hand_img.classList.remove('fadeIn');
    draw_hand_img.classList.add('fadeOut');
    awaitTimer(500).then(() => {
        draw_hand.classList.remove('handSwipe');
        draw_hand.style.display = 'none'
    })
}

export function revealTutorial() {
    console.log('reveal tutorial');
    tutorial.style.display = 'flex';
    tutorial.style.opacity = '0';
    tutorial.classList.remove('fadeOut');
    tutorial.classList.add('fadeIn');

    draw_buttons.forEach(button => {
        if (!button.classList.contains('draw_deleteButton')) {
            button.classList.remove('fadeIn50');
            button.classList.add('fadeOut50');
        }

        button.style.pointerEvents = 'none';
    });
    draw_infoButton.style.display = 'none';
    draw.style.pointerEvents = 'none';
    draw_cameraButton.style.pointerEvents = 'none';
}

export function hideTutorial(canUndo: boolean) {
    console.log('reveal tutorial');
    tutorial.classList.remove('fadeOut');
    tutorial.classList.add('fadeOut');
    awaitTimer(1000).then(() => {
        tutorial.style.display = 'none';
        draw_infoButton.style.display = 'flex';
        draw_cameraButton.style.pointerEvents = 'auto';
    })
    draw_buttons.forEach(button => {
        if (!button.classList.contains('draw_deleteButton')) {
            if (button.classList.contains('draw_undoButton')) {
                if (canUndo) {
                    button.classList.remove('fadeOut50');
                    button.classList.add('fadeIn50');
                }
            }
            else {
                button.classList.remove('fadeOut50');
                button.classList.add('fadeIn50');
            }
        }
        button.style.pointerEvents = 'auto';
    });
}

export function revealDraw() {
    console.log('reveal draw')
    draw.style.display = 'flex';
    draw.style.opacity = '0';
    draw_cameraButton.style.display = 'flex';
    draw.classList.remove('fadeOut');
    draw.classList.add('fadeIn');
    draw_cameraButton.classList.add('revealCameraButton');
    revealDrawTools()
}

export function hideDraw() {
    console.log('hide draw')
    draw.classList.remove('fadeIn');
    draw.classList.add('fadeOut');
    hideDrawTools();
    awaitTimer(500).then(() => {
        draw.style.display = 'none';
    })
}

export function revealDrawTools() {
    console.log('reveal draw tools')
    draw_buttonContainer.style.display = 'flex';
    draw_buttonContainer.classList.remove('moveRight');
    draw_buttonContainer.classList.add('moveLeft');
}

export function hideDrawTools() {
    console.log('hide draw tools')
    draw_buttonContainer.style.display = 'flex';
    draw_buttonContainer.classList.remove('moveLeft');
    draw_buttonContainer.classList.add('moveRight');
}

export function createColorButton(colorButton: HTMLButtonElement, color: string) {
    colorButton.style.flex = 'flex: 0 0 auto'
    colorButton.style.display = "inline-block";
    colorButton.style.height = '13.55vw';
    colorButton.style.width = '13.55vw';
    colorButton.style.border = 'white 3px solid';
    colorButton.style.borderRadius = '100%'
    colorButton.style.margin = '1vw';
    colorButton.style.backgroundColor = '#' + color;
    penSelection_colors.append(colorButton);
}

export function selectColorButton(colorButton: HTMLButtonElement, color: string) {
    colorButton.style.outline = '3px solid black'
}

export function deselectColorButton(colorButton: HTMLButtonElement) {
    colorButton.style.outline = 'none'
}


export function changePenUI(color: string, currentPen: string) {
    currentPen = currentPen.replace("b", "B")
    console.log(color, currentPen)
    console.log("https://ddg67ecygv8rc.cloudfront.net/sharpie/pens/" + currentPen.replace("b", "") + "_Uncapped_" + color + ".png")
    draw_pen.src = "https://ddg67ecygv8rc.cloudfront.net/sharpie/pens/" + currentPen.replace("#", "") + "_Uncapped_" + color + ".png";
    draw_colour.style.backgroundColor = "#" + color;

}

export function revealDrawDeleteMenu() {
    draw_deleteMenu.style.display = 'flex';
    draw_hand.style.display = 'none'
}

export function hideDrawDeleteMenu() {
    draw_deleteMenu.style.display = 'none';
}

export function selectButton(button: HTMLButtonElement) {
    deselectButtons();
    button.classList.add('selected')
}

export function deselectButtons() {
    draw_buttons.forEach(button => {
        button.classList.remove('selected')
    });
}

export function quickSelectButton(button: HTMLButtonElement) {
    button.classList.add('selected')
    awaitTimer(100).then(() => {
        button.classList.remove('selected')
    })
}

export function startCameraButtonAnim() {
    draw_cameraLoader.classList.add("recording");
}

export function stopCameraButtonAnim() {
    draw_cameraLoader.classList.remove("recording");
    draw_cameraLoader.style.clipPath = "polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)";
}

export function revealDownloadData(isVid: boolean) {
    console.log('reveal download data')
    console.log('isVid', isVid);
    download_video.style.display = isVid ? "block" : "none";
    download_image.style.display = isVid ? "none" : "block";
}

export function revealDownloadPage() {
    console.log('reveal download page')
    download.style.display = "flex";
}

export function hideDownloadPage() {
    console.log('hide download page')
    download.style.display = "none";
    download_image.src = "";
    download_video.src = "";
    download_video.style.display = "none";
    download_image.style.display = "none";
}

export function hidePenSelectionHand() {
    penSelection_hand.classList.add('fadeOut')
}

export function setDownloadForiOS() {
    console.log('setDownloadForiOS')
    download_saveButton.style.display = 'none';
    download_shareButton.style.display = 'none';
    download_saveShareButton.style.display = 'flex';
}

export function setUpLanguage(language: string) {
    if (language == 'fr' || language == 'es') {
        console.log(language)
        if (language == 'es') {
            prompt_subheading.style.fontSize = '0.9rem';
        }
        intro_1.style.fontSize = '1.3rem'
        intro_2.style.fontSize = '1.3rem'
        prompt_heading.style.fontSize = '0.75rem';
        prompt_footer.style.fontSize = '0.85rem';
        prompt_button.style.fontSize = '0.8rem';
        tutorial.style.fontSize = "2.2vh";
    }
}

export function setUndoButton(canUndo: boolean) {
    console.log('setUndoButton', canUndo)
    if (canUndo) {
        draw_undoButton.classList.remove('fadeOut50');
        draw_undoButton.classList.add('fadeIn50');
    }
    else {
        draw_undoButton.classList.remove('fadeIn50');
        draw_undoButton.classList.add('fadeOut50');
    }


}